import React from 'react';

interface IFileInfoProps {
  displayName: string;
  endPage?: number;
  fileSize: number;
  hasFile: boolean;
  hasSplitPdf?: boolean;
  onEditPages?: () => void;
  onMouseOverLink: () => void;
  onMouseExitLink: () => void;
  onRemoveFile: () => void;
  startPage?: number;
}

const FileInfo: React.SFC<IFileInfoProps> = (props: IFileInfoProps) => {
  const hasPages = typeof props.startPage === 'number' && typeof props.endPage === 'number';

  return (
    <div
      className="file-info"
      onMouseEnter={props.onMouseOverLink}
      onMouseLeave={props.onMouseExitLink}
      onTouchStart={props.onMouseOverLink}
      onTouchEnd={props.onMouseExitLink}
    >
      <div className="name">{props.displayName || ''}</div>
      {hasPages && <div className="page-numbers">{`pg. ${props.startPage}-${props.endPage}`}</div>}
      {props.hasFile &&
        !hasPages && (
          <div className="size">
            {props.fileSize >= 1000000
              ? `${Number((props.fileSize / 1000000).toPrecision(3))} MB`
              : `${Number((props.fileSize / 1000).toPrecision(3))} KB`}
          </div>
        )}
      {props.hasFile &&
        (props.hasSplitPdf || hasPages) && (
          <div className="edit-pages clickable" onClick={props.onEditPages}>
            Edit pages
          </div>
        )}
      {(!hasPages || props.hasSplitPdf) && (
        <div className="delete" onClick={props.onRemoveFile}>
          Delete file
        </div>
      )}
    </div>
  );
};

export default FileInfo;
